module.exports = __webpack_public_path__ + "2ea3f15f8f9233b12dfb9096e1c92288.png";